import ajaxCrud from "@/services/ajaxCrud";
import { endpointMappingPeriodo } from "../../../constants";

export default {
  getAll(cb = null) {
    ajaxCrud.getAll(endpointMappingPeriodo, cb);
  },

  get(id, cb) {
    ajaxCrud.get(endpointMappingPeriodo, id, cb);
  },

  update(id, data = {}, cb) {
    ajaxCrud.update(endpointMappingPeriodo, id, data, cb);
  },

  create(data = {}, cb) {
    ajaxCrud.create(endpointMappingPeriodo, data, cb);
  },

  delete(id, cb) {
    ajaxCrud.delete(endpointMappingPeriodo, id, cb);
  },

  massDelete(ids, cb) {
    ajaxCrud.massDelete(endpointMappingPeriodo, ids, cb);
  },

  massUpdate(rows, cb) {
    ajaxCrud.massUpdate(endpointMappingPeriodo, rows, cb);
  },
};
